export default __webpack_public_path__ + "static/media/Thumbnail-Newsletter-8.e74293f9.png";